// CPT Article

; (function (jQuery) {

	"use strict";

	function CPT_Articles() {

		var fn = {

			init: function ()
			{
				jQuery('.articles-filters select').on('change', fn.updateURLparameters);
				jQuery('.article-search-submit').on('click', fn.updateURLparameters);
				jQuery('.article-search-clear').on('click', fn.clearSearch);
			},

			updateURLparameters: function(e)
			{
				e.preventDefault();
				// Builds up new URL to submit
				var pageURL = jQuery('.articles-filters').data('article-directory-url');
				var queryParams = [];
				// Add Search terms
				if (jQuery('#article-search-keywords').val() != "") {
					queryParams.push("term=" + jQuery('#article-search-keywords').val());
				}
				// Add Filter terms
				jQuery('.articles-filters select option:selected').each(function() {
					if (jQuery(this).val() != "All") {
						queryParams.push(jQuery(this).closest('select').attr('id') + "=" + jQuery(this).val());
					}
				});
				//console.log(queryParams);
				if (queryParams.length !== 0) {
					pageURL += '?' + queryParams.join('&');
				}
				//console.log(pageURL);
				window.location = pageURL;
			},

			clearSearch: function(e)
			{
				jQuery('#article-search-keywords').val("");
				fn.updateURLparameters(e);
			}

		}

		jQuery(fn.init);

	}

	new CPT_Articles();

})(jQuery);